import { Injectable } from '@angular/core';
import { RegbpService } from '../api/src/app/services/regbp.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { KeyValue } from '@angular/common';
import { Country } from '../api/src/app/models/REGBP-V1.0.0/country.model';

@Injectable({
  providedIn: 'root'
})
export class CountryFacade {
  constructor(public regbpService: RegbpService) {}
  getCountries(language: string): Observable<KeyValue<string, string>[]> {
    return this.regbpService.getCountryList(language).pipe(
      map((results: any) => results.$response.body.values),
      map((results: Country[]) =>
        results
          .sort((a, b) => (a.value > b.value ? 1 : b.value > a.value ? -1 : 0))
          .map((countryObject: Country) => {
            return {
              key: countryObject.code,
              value: countryObject.value
            };
          })
      )
    );
  }
}
